import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type ActivityTimeStartData = {
  orderUuid: any;
  activityUuid: string;
  comment?: string;
  activityName?: string;
};

const usePostActivityTimeStart = (
  options?: UseMutationOptions<any, Error, ActivityTimeStartData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['startActivityTime'],
    mutationFn: async (data: ActivityTimeStartData) => {
      return axiosInstance.post(`/activity/time-start`, data).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Rozpoczynanie liczenia czasu dla aktywności...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'start-activity-time',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Czas dla aktywności rozpoczęty pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'start-activity-time',
      });
      queryClient.invalidateQueries({ queryKey: ['timeManagement'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas rozpoczynania mierzenia czasu dla aktywności.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'start-activity-time',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePostActivityTimeStart;
